import { useLocation, useNavigate } from 'react-router-dom'
import { UserAccountMenu } from './UserAccountMenu'

/**
 * Floating wrapper that renders the SAME `UserAccountMenu` used in the
 * sidebar footer, just inside a fixed-position panel for pages where
 * the sidebar is hidden (`/templates`, `/pricing`, ...).
 *
 * The only behavioural override vs. the sidebar version: picking a
 * workspace from the dropdown does NOT navigate to `/projects?workspace=...`
 * — it stays on the current page and just swaps the `workspace` query
 * param. So a user on `/templates` who switches workspace just sees
 * the template library re-render from the new workspace's viewpoint,
 * with whatever modal/pricing state they had still open.
 */
export default function FloatingWorkspaceSwitcher() {
  const navigate = useNavigate()
  const location = useLocation()

  const handleWorkspaceSwitch = (workspaceId) => {
    const params = new URLSearchParams(location.search)
    params.set('workspace', workspaceId)
    navigate(
      { pathname: location.pathname, search: `?${params.toString()}` },
      { replace: true },
    )
  }

  return (
    <div
      className={[
        'fixed bottom-3 left-3 z-40 w-[260px] p-1',
        // Match Catalyst's DropdownMenu surface exactly — same radius,
        // same translucent backdrop-blur, same shadow + ring — so the
        // trigger card and the dropdown that opens above it read as one
        // continuous piece of UI instead of two random rectangles.
        'rounded-xl bg-white/75 backdrop-blur-xl shadow-lg ring-1 ring-zinc-950/10',
        'dark:bg-zinc-800/75 dark:ring-white/10',
      ].join(' ')}
    >
      <UserAccountMenu onWorkspaceSwitch={handleWorkspaceSwitch} />
    </div>
  )
}
